import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GroupService, GroupSettingsModel, PageService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as moment from 'moment';


import jsPDF from 'jspdf';


import {   ReorderService , PdfExportService,  ToolbarItems, ColumnModel,  FilterService, PdfExportProperties, ColumnChooserService, GroupEventArgs, ResizeService, SortEventArgs, PdfQueryCellInfoEventArgs, ExcelExportService  } from '@syncfusion/ej2-angular-grids';
import {
  PdfStandardFont,
  PdfFontFamily,
  PdfFontStyle,
  PdfPageOrientation,
} from '@syncfusion/ej2-pdf-export';

@Component({
  selector: 'app-prenotazioni',
  templateUrl: './prenotazioni.component.html',
  styleUrls: ['./prenotazioni.component.css'],
  providers: [ PageService,SortService,ToolbarService,GroupService,PdfExportService],
})
export class PrenotazioniComponent implements OnInit {
  @ViewChild('prenotazionitable')public prenotazionitable: any;
  
  listFields:any[]=[];
  prenotazioniList:any[]=[];
  toolbar: string[];
  groupOptions?: GroupSettingsModel;
  pageTitle:string='';
  listParams:any={};
  toolbarOptions?: ToolbarItems[];
  struttureList:any[]=[];
  newRecordUrl:string='';
  editRecordUrl:string='';
  deleteRecordUrl:string='';
  isLoading=true;
  struttura_id:number=0;
  dal_giorno:Date=new Date();
  al_giorno:Date=new Date();
  sintesiPiatti:boolean=false;
  pasto:string='';
  pastoList:any []=[
    {value:'',label:'Pranzo e cena'},
    {value:'pranzo',label:'Pranzo'},
    {value:'cena',label:'Cena'}
  ];
  exportProperties?: PdfExportProperties;
  
  fileName:string="Prenotazioni.pdf";


  constructor(
      private globalService: GlobalService,
      private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.toolbarOptions = ['PdfExport','Search'];

    this.groupOptions = {showDropArea: true, showGroupedColumn:false, columns: [] };
    this.apiService.get('mensa/getstrutture',{}).subscribe((data)=>{
      this.struttureList=data.Result;
      if(this.globalService.loggedUser.struttura_id){
        this.struttura_id=this.globalService.loggedUser.struttura_id;
       
      } else {
        this.struttura_id=JSON.parse(localStorage.getItem('mensa_struttura_id'));
      
      }
      if(!this.struttura_id && this.struttureList.length>0){
        this.struttura_id=this.struttureList[0].value;
      }
      if(this.struttura_id){ 
        this.listParams.struttura_id=this.struttura_id;
        let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
        this.pageTitle="Struttura "+f[0].text;
        this.newRecordUrl='dashboard/gestionemensa/ricette/ricette-edit/new/'+f[0].text+'/'+this.struttura_id+'/';
        this.editRecordUrl='dashboard/gestionemensa/ricette/ricette-edit/update/'+f[0].text+'/'+this.struttura_id+'/';
        this.deleteRecordUrl='dashboard/gestionemensa/ricette/ricette-edit/delete/'+f[0].text+'/'+this.struttura_id+'/';
        localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
        this.changeStruttura({value:this.struttura_id});
      }
      this.isLoading=false;
    });
   
    this.listFields=
    [
      {
        field:'id',
        type:'edit',
        pSortableColumnDisabled:true,
        style:'width:50px;text-align:center;'
      },
      {
        field:'Mese',
        type:'field',
        header:'Mese',
        style:'width:100px;text-align:center;'
      },
      {
        field:'giorno',
        type:'date',
        header:'Giorno'
      },
      {
        field:'Pasto',
        type:'field',
        header:'Pasto'
      },
      {
        field:'prezzo',
        type:'currency',
        header:'Prezzo'
      },
      {
        field:'USER',
        type:'field',
        header:'Utente'
      },
      {
        field:'TipoUtente',
        type:'field',
        header:'Tipo utente'
      },
      {
        field:'Ospite',
        type:'field',
        header:'Ospite'
      },
    ];
  }

  userCannotChangeStruttura(){
     if(this.globalService.loggedUser.struttura_id){
      return true;
     } else {
      return false;
     }
  }

  loadData(){
     
      let  listParams:any={
            struttura_id:this.struttura_id,
            pasto:this.pasto
          };
        if(this.dal_giorno) {
            listParams.dal_giorno=moment(this.dal_giorno).format('YYYY-MM-DD');
          }
          if(this.al_giorno) {
            listParams.al_giorno=moment(this.al_giorno).format('YYYY-MM-DD');
          }
          
      this.apiService.get('mensa/mensa_prenotazioni_getall',listParams).subscribe((data)=>{
        this.prenotazioniList=data.Result;
    
        this.prenotazionitable.localeObj.currentLocale.EmptyRecord = 'Nessun dato presente'; 
      });
  }
 
   changeStruttura(event=null){

    if(event){
      this.struttura_id=event.value;
    }

    localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
    if(!this.isLoading){
      window.location.reload();
    }
  
    
  }

    toolbarClick(args: any): void {
      let doc: any = new jsPDF("l", "mm", "a4");
      
      let d=new Date();
      let dformat = [d.getMonth()+1,
        d.getDate(),
        d.getFullYear()].join('_')+'_'+
       [d.getHours(),
        d.getMinutes(),
        d.getSeconds()].join('_');
    
      let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
      let title='Prenotazioni mensa '+f[0].text+' '+moment(this.dal_giorno).format('DD/MM/YYYY')+ ' / ' +moment(this.al_giorno).format('DD/MM/YYYY'); //+this.Category+' '+this.Subcategory;
      if(moment(this.al_giorno).format('DD/MM/YYYY')==moment(this.dal_giorno).format('DD/MM/YYYY')){
        title='Prenotazioni mensa '+f[0].text+' '+moment(this.dal_giorno).format('DD/MM/YYYY'); //+this.Category+' '+this.Subcategory;
      }
      let header=['Mese','Giorno','Pranzo/Cena','Piatti','Prezzo','Utente','TipoUtente','Ospite'];
      

      if (args.item.prefixIcon=== 'e-pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
        let tb=[];
        this.prenotazioniList.forEach((p:any)=>{
          tb.push([p.Mese,moment(p.giorno).format('DD/MM/YYYY'),p.Pasto,p.piatti,p.prezzo+' €',p.USER,p.TipoUtente,p.Ospite]);
        });
        this.globalService.doTable(doc,title,header,tb);
         doc.save(title+dformat+'.pdf');
      }
  }

  
  pdfQueryCellInfo(args: any): void {
    (args as any).value =(args as any).value.replace(/[^\x20-\x7E]/g, '');
  }


}
